module.exports = __webpack_public_path__ + "static/logo_mds_title_white-1affbe7c735198b84766b6117d92f9ea.svg";